const buildHeaders = (apiKey: string): HeadersInit => {
  let headers: HeadersInit = new Headers({ 'Content-Type': 'application/json' });
  if (apiKey && apiKey !== '') {
    headers.set('X-Api-Key', apiKey);
  }
  return headers;
};

export { buildHeaders };
